<template>
	<div :ref="fieldRef" class="record-audio-field pb-8">
		<default-widget-field v-bind="defaultFieldProps" v-on="defaultFieldListeners" />
		<div class="text-left audio_field" style="position: relative">
			<VueRecordAudio :widgetID="widgetID" :fieldValue.sync="value" :selectedRecord.sync="lastRecordSource" @result="onResult" />
		</div>
	</div>
</template>

<script>
import WidgetFieldMixin from './WidgetFieldMixin';
import DefaultWidgetField from './DefaultWidgetField';
import VueRecordAudio from '../../WidgetForm/Recorder/VueRecordAudio';

export default {
	name: 'RecordAudioField',
	components: {
		VueRecordAudio,
		DefaultWidgetField,
	},
	mixins: [WidgetFieldMixin],
	props: {},
	computed: {
		widgetID() {
			return this.field?.widget;
		},
	},
	methods: {
		onResult(data) {
			this.lastRecordSource = window.URL.createObjectURL(data);
		},
	},
	data() {
		return {
			lastRecordSource: null,
		};
	},
};
</script>

<style scoped lang="scss">
.record-audio-field {
}
</style>
